import {getUserCampaignId} from '../reducers/userCampaign';
import {getCurrentCompanyId} from '../reducers/companies';
import {getCurrentTest} from '../reducers/tests';
import {createRepo} from '../services/repo';

const samplesRepo = createRepo({
  modelName: 'sample',
  plural: 'samples',
  isGlobal: true,
  getURL(getState) {
    const state = getState();
    const campaignId = getUserCampaignId(state);
    const test = getCurrentTest(state);
    const testId = test && test.get('id');

    return `users/assessed/${campaignId}/${testId}`;
  },
  getCurrentCompanyId
});

export const {loadSamplesFromRepo} = samplesRepo.actionCreators;

export function loadSamples() {
  return loadSamplesFromRepo;
}
